import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

import { DailyCountWidgetVm } from 'app/shared/generated/Dashboard/Models/DailyCountWidgetVm';
import { LandingService } from '../landing.service';

@Component({
    selector: 'pcg-daily-count-status',
    templateUrl: './daily-count-status.component.html',
    styleUrls: ['./daily-count-status.component.scss'],
    standalone: false
})
export class DailyCountStatusComponent implements OnInit {
    
    formGroup = DailyCountWidgetVm.Form;
    model = DailyCountWidgetVm.GetModel(this.formGroup);
    model$: Observable<DailyCountWidgetVm>;    
    
    constructor(public landingService: LandingService, private router: Router) { }

    ngOnInit(): void {
        this.model$ = this.landingService.getDailyCountWidgetVm().pipe(
            tap((model: DailyCountWidgetVm) => {
                this.formGroup.setValue(model);
            }));
    }

    linkClick(id: number, statusId: number) {
        id === 0 ? this.router.navigate(['/reports/inventory-count'], {
            queryParams: {
                param: id,
                status: statusId,
                current: this.model.current.countDate
            }
        }) : this.router.navigate(['/reports/inventory-count'], {
            queryParams: {
                param: id,
                status: statusId,
                previous: this.model.previous.countDate
            }
        })
    }
}